var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('iframe',{ref:"iframeDom",attrs:{"id":"iframeDom","src":_vm.srcUrl,"frameborder":"0","allowfullscreen":"true","webkitallowfullscreen":"true","mozallowfullscreen":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }